<kpd-detail-entity-tabs
  [facade]="roleFacade"
  [navigatorHelper]="navigatorHelper"
  (close)="onClose()"
  (itemChanged)="onItemChanged($event.item)"
  [updater]="entityUpdater"
  [viewMode]="viewMode"
  [entityTypeName]="'Role' | translate"
>
  <kpd-detail-tab [title]="'General' | translate" name="general">
    <ng-template>
      <app-role-details-general
        [item]="currentItem"
        [updater]="entityUpdater"
        (switchMode)="onSwitchMode($event)"
        (itemChanged)="onItemChanged($event)"
      ></app-role-details-general>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [disabled]="currentItem.isDeleted() || currentItem.isNew()"
    [title]="'Permission sets' | translate"
    icon="unlock"
    name="permissionSets"
    [badge]="tabLabels.permissionSetsCount.toString()"
  >
    <ng-template>
      <app-role-details-permissionsets
        [item]="currentItem"
        (switchMode)="onSwitchMode($event)"
        (itemChanged)="changeTabLabel('permissionSetsCount', $event)"
      >
      </app-role-details-permissionsets>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Users' | translate"
    name="users"
    icon="users"
    [badge]="tabLabels.userCount.toString()"
    *kpdPermission="showInEditPermission(Permissions.UserRoleUpdate, 'User.Read')"
    [disabled]="currentItem.isDeleted() || currentItem.isNew()"
  >
    <ng-template>
      <app-role-details-users
        [role]="currentItem"
        (switchMode)="onSwitchMode($event)"
        (userCountChanged)="changeTabLabel('userCount', $event)"
      ></app-role-details-users>
    </ng-template>
  </kpd-detail-tab>
</kpd-detail-entity-tabs>
